export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_OPEN_LEFT_MENU = 'SET_OPEN_LEFT_MENU';
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const SET_USER_FIELDS = 'SET_USER_FIELDS';
export const SET_CAPTCHA = 'SET_CAPTCHA';
